import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledStarIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.5244 5.08197C11.6741 4.62131 12.3259 4.62132 12.4756 5.08197L13.5449 8.37299C13.7457 8.99102 14.3218 9.41009 14.9717 9.4101H18.4326C18.917 9.4101 19.1184 10.0297 18.7266 10.3144L15.9268 12.3486C15.4011 12.7305 15.1812 13.4074 15.3818 14.0253L16.4512 17.3173C16.6008 17.778 16.0735 18.1616 15.6816 17.8769L12.8818 15.8417C12.3561 15.4599 11.6439 15.4599 11.1182 15.8417L8.31836 17.8769C7.9265 18.1616 7.39915 17.778 7.54883 17.3173L8.61816 14.0253C8.81877 13.4074 8.59887 12.7305 8.07324 12.3486L5.27344 10.3144C4.88158 10.0297 5.08302 9.4101 5.56738 9.4101H9.02832C9.67816 9.41009 10.2543 8.99102 10.4551 8.37299L11.5244 5.08197Z",
		fill: "white",
		stroke: "#30515B"
	})]
});
const ForwardRef = forwardRef(SvgFilledStarIcon);
const Memo = memo(ForwardRef);
export default Memo;
